const LogoCloud = () => {
  return (
    <div className="relative">
      <div className="">
        <h2 className="text-center uppercase font-secondary text-overline lg:text-overline-lg font-primary text-blue-700">
          MEMBERS ENJOY OFFERS FROM TRUSTED VENDORS LIKE THESE
        </h2>
      </div>

      <div className="mt-4 bg-blue-700 mx-auto rounded-[40px] lg:rounded-[50px] py-4 px-4 lg:py-12 lg:px-16">
          <div className="flex flex-wrap justify-between items-center">
            <div className="flex p-4 flex-grow flex-grow-0 lg:flex-grow-0">
              <img className="h-8 md:h-12 lg:h-[42px]" src="/images/homepage/logo-cloud/logo_5@2x.png" alt="constant contact logo" />
            </div>

            <div className="flex p-4 flex-grow flex-grow-0 lg:flex-grow-0">
              <img className="h-8 md:h-12 lg:h-[42px]" src="/images/homepage/logo-cloud/logo_4@2x.png" alt="miro logo" />
            </div>

            <div className="flex p-4 flex-grow flex-grow-0 lg:flex-grow-0">
              <img className="h-8 md:h-12 lg:h-[42px]" src="/images/homepage/logo-cloud/logo_3@2x.png" alt="moo logo" />
            </div>
    
            <div className="flex p-4 flex-grow flex-grow-0 lg:flex-grow-0">
              <img className="h-8 md:h-12 lg:h-[42px]" src="/images/homepage/logo-cloud/logo_1@2x.png" alt="skill share logo" />
            </div>

            <div className="flex p-4 flex-grow flex-grow-0 lg:flex-grow-0">
              <img className="h-8 md:h-12 lg:h-[42px]" src="/images/homepage/logo-cloud/logo_2@2x.png" alt="unbounce logo" />
            </div>
          </div>
      </div>
    </div>
  )
}

export default LogoCloud;

